import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';

import { connect } from 'react-redux';
import { login2, loggedIn, checked, checkedLoginNotLoggedIn, check } from 'actions/auth';
import { FORM_ERROR } from 'final-form'

import { removeAuthToken } from 'actions/api';
import { push, replace } from 'react-router-redux';
import { checkRoom2 } from 'actions/company';

import { Link } from 'react-router';
import nutzer from 'styles/images/nutzer.png';
import handw from 'styles/images/handw.png'

import LoginForm from 'components/forms/LoginForm';
import Logo from 'components/Logo';
import JoinForm from 'components/forms/JoinForm';
import SelectLanguageButton from 'components/SelectLanguageButton';
import ThemeToggle from 'components/ThemeToggle';


const messages = defineMessages({
  START_SESSION: {
    id: 'LoginPage.START_SESSION',
    defaultMessage: 'Sitzung starten',
  },
  ENTER_SESSION_NAME: {
    id: 'LoginPage.ENTER_SESSION_NAME',
    defaultMessage: 'Bitte geben Sie Ihren Sitzungsnamen an um eine Verbindung aufzubauen.',
  },
  LOGIN_COMPANY: {
    id: 'LoginPage.LOGIN_COMPANY',
    defaultMessage: 'Unternehmenslogin',
  },
  QUESTION_FORGOT_PASSWORD: {
    id: 'LoginPage.QUESTION_FORGOT_PASSWORD',
    defaultMessage: 'Passwort vergessen?',
  },
  STANDART_BUISSINESS_TERMS: {
    id: 'LoginPage.STANDART_BUISSINESS_TERMS',
    defaultMessage: 'AGB',
  },
  DATA_PRIVACY: {
    id: 'LoginPage.DATA_PRIVACY',
    defaultMessage: 'Datenschutz',
  },
  IMPRINT: {
    id: 'LoginPage.IMPRINT',
    defaultMessage: 'Impressum',
  },
  HANDBOOK: {
    id: 'LoginPage.HANDBOOK',
    defaultMessage: 'Handbuch'
  },
});

function checkOrRedirectIfLoggedIn(props) {
    const { checkedLogin, user, redirect } = props;
    if (!checkedLogin) {
        props.check();
    } else {
        if (!user) {
            return;
        }
        if (user.is_admin
            || user.company_count > 1) {
            redirect(props.location.query.next || '/company/');
            return;
        }
        redirect(props.location.query.next || `/company/${user.company_id}/`);
    }
}

class LoginPage extends React.PureComponent {
    componentWillMount() {
        checkOrRedirectIfLoggedIn(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.checkedLogin !== nextProps.checkedLogin) {
            checkOrRedirectIfLoggedIn(nextProps);
        }
    }

    render() {
      const { intl: { formatMessage } } = this.props;

        return (
            <div className="anonymous-container" style={{ minHeight: '100vh', width: '100%', position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '40px 20px', background: 'var(--bg-color)', overflow: 'hidden' }}>
                <div className="anonymous-card-wrapper" style={{ position: 'relative', width: '100%', maxWidth: '1000px', marginTop: '40px' }}>
                    {/* Glassmorphism Card */}
                    <div className="anonymous-card" style={{ position: 'relative', zIndex: 1, backgroundColor: 'var(--panel-bg)', borderRadius: '32px', boxShadow: 'var(--glass-shadow)', border: '1px solid var(--panel-border)', overflow: 'hidden' }}>
                        
                        <div className="anonymous-header" style={{ position: 'relative', padding: '48px 0', borderBottom: '1px solid var(--panel-border)', backgroundColor: 'var(--panel-bg)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                          <Logo large />
                          <div className="anonymous-theme-toggle">
                            <ThemeToggle />
                          </div>
                        </div>

                        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                            {/* Left Side: Login */}
                            <div className="login-section-left" style={{ flex: '1 1 400px', padding: '48px', borderRight: '1px solid var(--panel-border)' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '32px' }}>
                                    <img src={handw} alt="Unternehmenslogin" className="login-icon" style={{ width: '56px', height: '56px', objectFit: 'contain' }} />
                                    <h2 style={{ margin: 0, fontSize: '24px', fontWeight: 'bold', color: 'var(--text-color)' }}>{formatMessage(messages.LOGIN_COMPANY)}</h2>
                                </div>
                                <LoginForm
                                  onSubmit={this.props.login}
                                  reason={this.props.location.query.reason}
                                />
                                <div className="text-center" style={{ marginTop: '24px' }}>
                                    <Link to="/requestPasswortReset" style={{ color: '#3b82f6', fontWeight: '500', textDecoration: 'none' }} onMouseEnter={(e) => e.currentTarget.style.textDecoration='underline'} onMouseLeave={(e) => e.currentTarget.style.textDecoration='none'}>
                                        {formatMessage(messages.QUESTION_FORGOT_PASSWORD)}
                                    </Link>
                                </div>
                            </div>

                            {/* Right Side: Join Room */}
                            <div className="login-section-right" style={{ flex: '1 1 400px', padding: '48px' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '24px' }}>
                                    <img src={nutzer} alt="Sitzung starten" className="login-icon" style={{ width: '56px', height: '56px', objectFit: 'contain' }} />
                                    <h2 style={{ margin: 0, fontSize: '24px', fontWeight: 'bold', color: 'var(--text-color)' }}>{formatMessage(messages.START_SESSION)}</h2>
                                </div>
                                <p style={{ color: 'var(--text-muted)', marginBottom: '32px', fontSize: '15px' }}>{formatMessage(messages.ENTER_SESSION_NAME)}</p>
                                <JoinForm onSubmit={this.props.gotoRoom} />
                            </div>
                        </div>

                    </div>
                </div>

                {/* Footer Links */}
                <div style={{ marginTop: '48px', marginBottom: '24px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '24px', zIndex: 1 }}>
                    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '32px' }}>
                        <a href="https://www.tele-look.com/web/agb/" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--text-muted)', textDecoration: 'none', fontWeight: '500' }} onMouseEnter={(e) => e.currentTarget.style.color = '#3b82f6'} onMouseLeave={(e) => e.currentTarget.style.color = 'var(--text-muted)'}>{formatMessage(messages.STANDART_BUISSINESS_TERMS)}</a>
                        <a href="https://www.tele-look.com/web/impressum/" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--text-muted)', textDecoration: 'none', fontWeight: '500' }} onMouseEnter={(e) => e.currentTarget.style.color = '#3b82f6'} onMouseLeave={(e) => e.currentTarget.style.color = 'var(--text-muted)'}>{formatMessage(messages.IMPRINT)}</a>
                    </div>
                    <SelectLanguageButton textVersion />
                </div>
            </div>
        );
    }
}


export default connect(
    state => state.auth,
    (dispatch, props) => ({
        redirect: path => dispatch(replace(path)),
        check: () => check().then(
            user => dispatch(checked(user)),
            () => {
                // remove old token data if user login check not successful
                removeAuthToken();
                dispatch(checkedLoginNotLoggedIn());
            },
        ),
        login: async formData => {
          const data = await login2(formData);
          if (data.response) {
            dispatch(loggedIn(data.response));
            dispatch(push(props.location.query.next || '/'));
          } else {
            return { [FORM_ERROR]: data.error[Object.keys(data.error)[0]] };
          }
        },
        gotoRoom: async formData => {
          const data = await checkRoom2(formData);
          if (data.response) {
            dispatch(push(`/v/${data.response.slug}/`))
          } else {
            return { [FORM_ERROR]: data.error[Object.keys(data.error)[0]] };
          }
        }
/*
          checkRoom(formData).then(
            room => dispatch(push(`/v/${room.slug}/`))
        ),
 */
    })
)(injectIntl(LoginPage));
